import { Typography } from "antd";

const { Paragraph, Title } = Typography;
const RefundPolicy = () => {
  return (
    <div className="my-8">
      <Title level={3}>Cancellation and Refund Policy</Title>
      <Paragraph className="text-left my-8 px-16 max-sm:px-4">
        <p>
          Please, read this first before initiating a return. Returns will be
          accepted only when the following conditions are met:
        </p>
        <Title level={5}>Part A: Refrigeration and AC category</Title>
        <p>
          <ul>
            <li>
              If Cancellation happens within 24 hours of placing the order or
              before confirmation of ORDER from AAIPL, whichever is earlier,
              then full order value will be refunded.
            </li>
            <li>
              If cancellation request is raised post CONFIRMATION of order from
              AAIPL that then 10% of the total order PO value will be deducted
            </li>
            <li>
              If cancellation request is raised post-DISPATCH order from
              AAIPL/DISTRIBUOTR WAREHOUSE, then 10% of the total order value +
              to and fro Freight charges will be deducted.
            </li>
            <li>
              POST DELIVERY, refund is possible only against any manufacturing
              defects. In this case 100% refund will be made subject to material
              inspection. The product is returned in proper original packaging
              with no damage, scratches, or dents.
            </li>
          </ul>
        </p>
        <Title level={5}>Part B: Rest of the categories</Title>
        <p>
          <ul>
            <li>
              The product is returned in proper original packaging with no
              damage, scratches, or dents
            </li>
            <li>
              Product packaging is preserved in original condition with no
              damage, scratches, or grease stains
            </li>
            <li>
              The product is unused and in the same condition as it was at the
              time of receipt (with no sign of installation)
            </li>
            <li>
              Return request initiated within 7 days after products are
              delivered
            </li>
            <li>
              If received part(s) is damaged, return request is initiated within
              1 day of product delivery (10 days return window not applicable)
            </li>
          </ul>
        </p>
        <Title level={5}>Exemptions from the policy:</Title>
        <p>
          <ul>
            <li>
              Items which belong to the following categories are not subject to
              refund: electronic and complicated electric parts (harnesses,
              instrument panels, parts with circuit boards, etc.), car body
              covers, bug &amp; tar remover, air fresheners. You'll find
              Non-returnable mentioned on the product page for all the parts
              which have been exempted from this policy.
            </li>
            <li>
              Vendors/merchants can have their own requirements or refund
              policy.
            </li>
          </ul>
        </p>
        <Title level={5}>Key Points:</Title>
        <p>
          <ul>
            <li>
              Customer can initiate the return from their order panel in
              alpshop.in
            </li>
            <li>
              Customer shall check the consignment for any Physical damage and,
              if any found, mention this in POD (Proof of Delivery) documents of
              Logistics.
            </li>
            <li>
              We recommend taking photos of packages received and shooting an
              unpacking video of the product. In case of any problem with
              product share it at support@alpshop.in.
            </li>
            <li>
              In case of a return, do make a video while repacking the parts.
            </li>
            <li>
              While returning the package, the customer should make sure that
              the parts are repacked properly to ensure it does not get damaged
              in transit as Alpshop shall not be liable for refunds/return in
              case the part got damaged (while in transit) due to improper
              packaging.
            </li>
            <li>
              In case of a manufacturing defect/item's fault claim, the customer
              has to get the part inspected by a brand authorised service centre
              &amp; get an inspection report/document for further investigation.
            </li>
            <li>
              The final decision, in manufacturing defect/item's fault claim
              will be taken by Alpshop &amp; the supplier.
            </li>
            <li>
              Depending on the route and logistics services provider delivery
              time may vary. We cannot guarantee that we will receive your
              returned item.
            </li>
            <li>
              If you are self-shipping an item that costs more than Rs. 3500,
              you should consider using a trackable shipping service or/and
              purchasing shipping insurance.
            </li>
            <li>
              Shipping and finance (gateway) costs are not subject to refund.
              The cost of return shipping can be deducted from your refund.
            </li>
            <li>
              If the return claim was rejected, we will send it back on the
              customer's request or scrap after 30 days of keeping at stock. The
              customer will be responsible for paying all related shipping
              costs.
            </li>
          </ul>
        </p>
        <Title level={5}>Refunds:</Title>
        <p>
          After the returned product is received, inspected, and approved by our
          QC team, it would take 3-5 days for the refund to initiate. It
          usually, takes up to 5-7 working days for the refund amount to reflect
          in your source account. If you do not receive the refund within the
          above said time, please, contact your bank. Prepayment: In order to
          protect Payer, refunds will be done only through the Original Mode of
          Payment and to the same account from which it was originated, i.e. the
          Source account
        </p>
      </Paragraph>
    </div>
  );
};
export default RefundPolicy;
